import { CCard, CCardBody, CCardGroup, CCol, CContainer, CFormSelect, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ArrowLeft, ArrowLeftPagingSVG, ArrowLeftSSVG, ArrowLeftSVG, ArrowRight, ArrowRightSVG, ArrowRigthPagingSVG, ArrowRigthtSVG } from '../../../components/IconSvg'
import { activePackageForUserAction, getAvailablePackageListAction, getClientProductAction, getPackageServiceIdAction, getUpgradablePackagesAction, resetPackagePropsAction, upgradePackageAction } from '../../../service/actions/packageAction'
import PackageItem from './PackageItem'
import PropTypes from 'prop-types'
import { getDomainActionRequest } from '../../../service/actions/domainActions'
import SelectCurrency from './selectCurrency'
import { padding } from '@mui/system'
import CRBtn from './PackageItem/CustomRadioBtn'
import Slider from './Slider'
import Pay from '../Invoice/Pay'
import { publicWHMCSUrlPice } from '../../../components/helper'
import { toast } from 'react-toastify'
import NoData from '../../../components/NoData'
import UpgradablePackages from './upgradablePackages'

const PackageView = ({
  getPackages,
  pending,
  packageList,
  activePackage,
  activePackagePending,
  success,
  reset,
  domain,
  activatedPackage,
  getPackageServiceIdAction,
  getUpgradablePackages,
  packageServiceID,
  getPackageServiceIDPending,
  getUpgradablePackagesPending,
  upgradablePackages,
  upgradePackage,
  upgradePackageResult,
  getClientProduct,
  getClientProductSuccess,
  upgradePackagePending
}) => {

  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  let direction = i18n.dir()

  const [selectedPackage, seSelectedPackage] = useState()
  const location = useLocation();
  const [currency, setCurrency] = useState("IRR")
  const [duration, setDuration] = useState("Year")
  const [filteredPackages, setFilteredPK] = useState([])
  const [valueToggle, setValueToggle] = useState(false)
  const [mobileMood, setMobileMood] = useState(false)

  const [idActiveClick, setIdActiveClick] = useState()

  const [leftBtnSlider, setLeftBtnSlider] = useState(direction === 'rtl' ? false : true)
  const [rigthBtnSlider, setRightBtnSlider] = useState(direction === 'rtl' ? true : false)
  const [scrolledCount, setScrolledCount] = useState(3)
  const [invoicId, setInvoiceId] = useState()




  let autoResize = () => {
    setMobileMood(window.outerWidth < 1024)

  }

  useEffect(() => {
    window.onresize = autoResize
    autoResize();

    localStorage.setItem("pathPackageReference", "panel")
    if (location?.state?.upgradePackage) {

      setDuration(location.state.duration)
      setValueToggle(location.state.duration === "Month")
      getPackageServiceIdAction({ userId: JSON.parse(localStorage.getItem("sipOnlineUser"))?.userId })
    } else {
      handleGetPackage(currency)
    }
  }, [])

  useEffect(() => {
    if (packageServiceID) {
      getUpgradablePackages({ userId: JSON.parse(localStorage.getItem("sipOnlineUser"))?.userId, currency: currency })
    }
  }, [packageServiceID])

  useEffect(() => {
    if (packageList.data && !location.state?.upgradePackage) {
      handleFilterPackage()
    }

    if (upgradablePackages.data && location.state?.upgradePackage) {
      handleFilterUpgradablePackage()
    }
  }, [packageList, duration, upgradablePackages])

  const handleFilterPackage = () => {


    if (!upgradablePackages?.data && !packageList?.data) {
      return
    }
    let tempList = [...packageList?.data?.filter(i => i.isShow)];
    let filtered = []
    tempList.map(item => {
      if (item.durations.some(i => i.type === duration)) {
        let _temp = { ...item }
        _temp.durations = item.durations.filter(i => i.type === duration)
        filtered.push(_temp)
      }
    })

    setFilteredPK([...filtered])
  }

  const handleFilterUpgradablePackage = () => {

    if (!upgradablePackages?.data && !packageList?.data) {
      return
    }
    let tempList = [...upgradablePackages?.data];
    if (tempList) {
      tempList = tempList.filter(i => i.isShow)

      let filtered = []

      tempList.map(item => {
        if (item.durations.some(i => i.type === duration)) {
          let _temp = { ...item }
          _temp.durations = item.durations.filter(i => i.type === duration)
          filtered.push(_temp)
        }
      })
      setFilteredPK([...filtered])
    }

  }

  const handleGetPackage = (currency) => {
    setCurrency(currency)

    getPackages({
      currency,
      whereConditionText: "",
      sortText: "",
      pageSize: 10,
      pageNumber: 1,
      disablePaging: true
    })
  }

  useEffect(() => {
    if (upgradePackageResult && upgradePackageResult.result !== "error") {

      reset()
      let _price = upgradePackageResult.price.split(' ')[0]
      for (let i = 0; i < _price.length; i++) {
        _price = _price.replace(',', '')

      }
      _price = parseInt(_price)

      let reducedPrice = selectedPackage.duration[0].priceAmounts[0].price - _price


      if (upgradePackageResult?.invoiceid) {

        navigate(`/pay/${upgradePackageResult?.invoiceid}`, {
          state: {
            ...location.state,
            package: selectedPackage,
            _duration: selectedPackage.duration,
            upgradePackageResult: upgradePackageResult,
            reducedPrice,
            originPackagePrice: selectedPackage.duration[0].priceAmounts[0].price
          }
        })
      } else {
        toast.error(t("TOAST.PURCHASE_FAILED"))
      }


      // to get last user product features
      // getClientProduct({ userId: JSON.parse(localStorage.getItem("sipOnlineUser")).userId })
    }
    if (upgradePackageResult?.result === "error") {
      reset()

      toast.error(t("TOAST.PURCHASE_FAILED"))

    }

  }, [upgradePackageResult])


  useEffect(() => {
    if (success) {
      if (location?.state?.from === "auth") {
        seSelectedPackage()
        if (activatedPackage.isActive) {
          if (location?.state?.fromPanel) {
            navigate('/mypackage', { state: { package: activatedPackage } })

          } else {
            navigate('/setDomain', { state: { package: activatedPackage } })

          }
        } else {

          navigate(`/pay/${activatedPackage?.packageType?.invoiceIdWHMCS}`,
            {
              state: {
                ...location.state,
                package: selectedPackage,
                duration: selectedPackage.duration,

              }
            })
        }
      }
      else {
        setInvoiceId(activatedPackage?.packageType?.invoiceIdWHMCS)
      }
    }
    reset()
  }, [success]);

  useEffect(() => {
    if (currency) {
      if (location?.state?.upgradePackage) {
        if (packageServiceID) {
          getUpgradablePackages({ userId: JSON.parse(localStorage.getItem("sipOnlineUser"))?.userId, currency: currency })

        }

      } else {
        handleGetPackage(currency)

      }
    }
  }, [currency])

  const handleActivePackage = (features, durations, id) => {

    setIdActiveClick(id)



    if (location.state.upgradePackage) {

      const _package = upgradablePackages.data.find(i => i.id === id)
      seSelectedPackage({ package: _package, duration: durations, features: features })
      const params = {
        url: publicWHMCSUrlPice({
          action: "UpgradeProduct",
          serviceid: packageServiceID,
          type: "product",
          newproductid: _package.productIdInWHMCS,
          paymentmethod: "mellat",
          // attachments: encodeList,
          newproductbillingcycle: duration === "Month" ? "monthly" : "annually"
        }),

        method: "post",
        acceptBodyType: "",
        body: "string",
        userAgent: "string",
        headers: {
          "additionalProp1": "string"

        },
        responseType: "json"
      }

      upgradePackage(params)
    } else {
      const _package = packageList.data.find(i => i.id === id)
      seSelectedPackage({ package: _package, duration: durations, features: features })
      activePackage({
        userId: JSON.parse(localStorage.getItem("sipOnlineUser"))?.userId,
        Currency: currency,
        durationCount: 1,
        packageTypeId: id,
        durationId: durations[0].id,
        isActive: true,
        featureIds: features.map(item => item.id)
      })
    }


  }

  const handleChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    setValueToggle(value)
    if (value) {
      setDuration('Month')
    } else {
      setDuration('Year')
    }
  }

  const displayFilterValidation = () => {
    let list = [];
    if (upgradablePackages?.data) {
      let tempList = [...upgradablePackages?.data];
      if (tempList) {
        list = tempList.filter(i => i.isShow)
      }
    } else if (packageList?.data) {
      list = [...packageList?.data?.filter(i => i.isShow)];
    }
    let hasMonthly = false;
    let hasYearly = false;
    list.forEach((p) => {
      p.durations.forEach((d) => {
        if (d.type === "Year") {
          hasYearly = true;
        }
        if (d.type === "Month") {
          hasMonthly = true;
        }
      })
    })
    return { hasMonthly, hasYearly }
  }
  return (
    <div className={'wrapper d-flex flex-row justify-content-center align-items-center'}>
      <div className={'main-slider-container d-flex flex-column justify-content-start'}>


        {location?.state?.fromPanel ? <div className='d-flex flex-row justify-content-start  skip-container' >
          <div className={`${mobileMood ? 'mobile-device' : ''} skip-button-holder d-flex flex-row  justify-content-end`}  >
            <div className='skip-button d-flex flex-row  justify-content-between' style={{ width: '100px' }} onClick={() => {

              navigate("/mypackage");
            }}>
              {direction === 'rtl' ? <span><ArrowRightSVG /></span> : <span><ArrowLeftSSVG /></span>
              }
              <span>{t("MENU.BACK")}</span>


            </div>
          </div>
        </div>
          : ''}

        {filteredPackages?.length > 0 && <div className='d-flex flex-row justify-content-center toggel-container' >
          <div className='d-flex align-items-center  justify-content-center' >
            <div className="your-required-wrapper" >
              {displayFilterValidation(filteredPackages).hasMonthly ? <CRBtn text1={t("PACKGE.MONTHLY")} text2={t("PACKGE.YEARLY")} value={valueToggle} handleChange={handleChange} /> :
                <div className='filter-item-spn'>{t("PACKGE.YEARLY")}</div>
              }

            </div>
          </div>
        </div>}
        {location?.state?.upgradePackage && upgradablePackages.data?.length > 0 &&
          <div className='d-flex justify-content-center p-2'>
            <b>{t("UPGRADABLE_PACKAGE_FOR_YOU")}</b> </div>}

        <div className='d-flex flex-row justify-content-center'>
          <div>
            {(pending || getPackageServiceIDPending || getUpgradablePackagesPending) &&
              <div className='loading-context'>
                <div className="spinner-border" role="status" aria-hidden="true"></div>
              </div>

            }
            {(packageList.data || upgradablePackages.data) && !location?.state?.upgradePackage &&
              <Slider
                className="slider-content"
                list={filteredPackages}
                selectItem={seSelectedPackage}
                selected={selectedPackage}
                handleActivePackage={handleActivePackage}
                activePackagePending={activePackagePending || upgradePackagePending}
                idActiveClick={idActiveClick}
                mobileMood={mobileMood}
                duration={duration}
              />}

            {location?.state?.upgradePackage && upgradablePackages.data?.length > 0 && <UpgradablePackages
              list={filteredPackages}
              selectItem={seSelectedPackage}
              selected={selectedPackage}
              handleActivePackage={handleActivePackage}
              activePackagePending={activePackagePending || upgradePackagePending}
              idActiveClick={idActiveClick}
              mobileMood={mobileMood}
              duration={duration}
            />}
            {location?.state?.upgradePackage &&
              !getUpgradablePackagesPending &&
              upgradablePackages.data?.length === 0 &&
              <NoData title={t('NO_UPGRADABLE_PACKAGE_FOR_YOU')} />}

          </div>
        </div>
      </div>
      {invoicId &&
        <Pay pageType={location?.state?.from !== "auth"}
          invoicId={invoicId}
          setInvoiceId={setInvoiceId}
          package={selectedPackage}
          purchasedPackage={selectedPackage} />}

    </div>


  )
}

PackageView.propTypes = {
  pending: PropTypes.bool,
  success: PropTypes.bool,
  packageList: PropTypes.object,
  activePackage: PropTypes.func,
  getPackages: PropTypes.func,
  reset: PropTypes.func
}

const mapStateToProps = (state) => ({
  pending: state.packageReducer.getAvailablePackagesPending,
  packageList: state.packageReducer.availablePackages,
  success: state.packageReducer.activePackageSuccess,
  activatedPackage: state.packageReducer.activatedPackage,
  activePackagePending: state.packageReducer.activePackagePending,
  domain: state.domainReducer.domain,
  upgradablePackages: state.packageReducer.getUpgradablePackagesResult,
  getUpgradablePackagesPending: state.packageReducer.getUpgradablePackagesPending,
  getPackageServiceIDPending: state.packageReducer.getPackageServiceIDPending,
  packageServiceID: state.packageReducer.getPackageServiceIDResult,
  upgradePackageResult: state.packageReducer.upgradePackageResult,
  upgradePackagePending: state.packageReducer.upgradePackagePending,

  getClientProductSuccess: state.packageReducer.getClientProductSuccess,

})

const mapDispatchToProps = (dispatch) => ({
  getPackages: (params) => dispatch(getAvailablePackageListAction(params)),
  activePackage: (params) => dispatch(activePackageForUserAction(params)),
  reset: () => dispatch(resetPackagePropsAction()),
  getDomain: () => dispatch(getDomainActionRequest()),
  getUpgradablePackages: (params) => dispatch(getUpgradablePackagesAction(params)),
  getPackageServiceIdAction: (params) => dispatch(getPackageServiceIdAction(params)),
  upgradePackage: (params) => dispatch(upgradePackageAction(params)),
  getClientProduct: (params) => dispatch(getClientProductAction(params)),

})

export default connect(mapStateToProps, mapDispatchToProps)(PackageView)


const temp = {}